module.exports = __webpack_public_path__ + "img/vip-icon2.363ad028.png";